import { AccountList, AccountListParams } from '@repo/accounts-types'
import { ApiResponse } from '@repo/core'
import { AxiosInstance, AxiosRequestConfig, AxiosResponse } from 'axios'

export const getAccountList = async ({
  api,
  params,
  config,
}: {
  api: AxiosInstance
  params?: AccountListParams
  config?: Pick<AxiosRequestConfig, 'signal'>
}): Promise<AxiosResponse<ApiResponse<AccountList>>> => {
  return api.get<ApiResponse<AccountList>>('/accounts/securities', {
    params,
    ...config,
  })
}
